export const LOCALE_CONFIG = {
  // ── North America ──
  'en-us': {
    country: 'United States', currency: 'USD', symbol: '$', lang: 'en',
    debtTypes: ['Credit Card','Store / Retail Card','Personal Loan','Car Loan','Student Loan','Medical Debt','Home Equity Loan','Payday Loan','Buy Now Pay Later','Family / Friend Loan','Other'],
    metaTitle: 'Free Debt Payoff Calculator — Pay Off Debt Fast | ClearMyDebt',
    metaDesc: 'Use our free debt payoff calculator. Snowball & avalanche methods. No signup. Instant results.',
  },
  'es-us': {
    country: 'United States (Spanish)', currency: 'USD', symbol: '$', lang: 'es',
    debtTypes: ['Tarjeta de Crédito','Tarjeta de Tienda','Préstamo Personal','Préstamo de Auto','Préstamo Estudiantil','Deuda Médica','Préstamo con Garantía Hipotecaria','Préstamo de Día de Pago','Buy Now Pay Later','Préstamo Familiar','Otro'],
    metaTitle: 'Calculadora de Deudas Gratis — Sal de Deudas | ClearMyDebt',
    metaDesc: 'Calculadora gratuita para pagar tus deudas. Ve tu fecha exacta para quedar libre de deudas usando los métodos Avalanche y Snowball. Sin registro. Resultados al instante.',
  },
  'en-ca': {
    country: 'Canada', currency: 'CAD', symbol: 'CA$', lang: 'en',
    debtTypes: ['Credit Card','Line of Credit','Personal Loan','Car Loan','Student Loan','HELOC','Medical Debt','Buy Now Pay Later','Family / Friend Loan','Other'],
    metaTitle: 'Free Debt Repayment Calculator Canada — Pay Off Debt | ClearMyDebt',
    metaDesc: 'Calculate your debt repayment plan. Snowball & avalanche. No signup. Instant results.',
  },
  'es-mx': {
    country: 'Mexico', currency: 'MXN', symbol: 'MX$', lang: 'es',
    debtTypes: ['Tarjeta de Crédito','Préstamo Personal','Crédito de Auto','Préstamo Estudiantil','Deuda Médica','Buy Now Pay Later','Préstamo Familiar','Otro'],
    metaTitle: 'Calculadora de Deudas Gratis — Salir de Deudas | ClearMyDebt',
    metaDesc: 'Calcula cuándo estarás libre de deudas. Sin registro. Resultados instantáneos.',
  },
  'es-ar': {
    country: 'Argentina', currency: 'ARS', symbol: 'AR$', lang: 'es',
    debtTypes: ['Tarjeta de Crédito','Préstamo Personal','Préstamo Automotor','Préstamo Estudiantil','Deuda Médica','Buy Now Pay Later','Préstamo Familiar','Otro'],
    metaTitle: 'Calculadora de Deudas Gratis — Salir de Deudas | ClearMyDebt',
    metaDesc: 'Calcula cuándo estarás libre de deudas. Sin registro. Resultados instantáneos.',
  },
  'es-co': {
    country: 'Colombia', currency: 'COP', symbol: 'COL$', lang: 'es',
    debtTypes: ['Tarjeta de Crédito','Crédito Personal','Crédito de Vehículo','Crédito de Estudios','Deuda Médica','Buy Now Pay Later','Préstamo Familiar','Otro'],
    metaTitle: 'Calculadora de Deudas Gratis — Salir de Deudas | ClearMyDebt',
    metaDesc: 'Calcula cuándo estarás libre de deudas. Sin registro. Resultados instantáneos.',
  },
  'es-cl': {
    country: 'Chile', currency: 'CLP', symbol: 'CLP$', lang: 'es',
    debtTypes: ['Tarjeta de Crédito','Préstamo Personal','Crédito Automotriz','Crédito Estudiantil','Deuda Médica','Buy Now Pay Later','Préstamo Familiar','Otro'],
    metaTitle: 'Calculadora de Deudas Gratis — Salir de Deudas | ClearMyDebt',
    metaDesc: 'Calcula cuándo estarás libre de deudas. Sin registro. Resultados instantáneos.',
  },
  'pt-br': {
    country: 'Brazil', currency: 'BRL', symbol: 'R$', lang: 'pt',
    debtTypes: ['Cartão de Crédito','Empréstimo Pessoal','Financiamento de Carro','Empréstimo Estudantil','Dívida Médica','Cheque Especial','Crédito Consignado','Outro'],
    metaTitle: 'Calculadora de Dívidas Grátis — Pagar Dívidas | ClearMyDebt',
    metaDesc: 'Calcule quando ficará livre de dívidas. Sem cadastro. Resultados instantâneos.',
  },

  // ── UK & English-speaking Europe ──
  'en-gb': {
    country: 'United Kingdom', currency: 'GBP', symbol: '£', lang: 'en',
    debtTypes: ['Credit Card','Overdraft','Personal Loan','Car Finance (PCP)','Student Loan','Store Card','Buy Now Pay Later','Mortgage Overpayment','Council Tax Debt','Family / Friend Loan','Other'],
    metaTitle: 'Free Debt Repayment Calculator — Pay Off Debt Faster | ClearMyDebt',
    metaDesc: 'Calculate your debt repayment plan. Snowball & avalanche. No signup. Instant results.',
  },
  'en-ie': {
    country: 'Ireland', currency: 'EUR', symbol: '€', lang: 'en',
    debtTypes: ['Credit Card','Overdraft','Personal Loan','Car Loan','Student Loan','Buy Now Pay Later','Family / Friend Loan','Other'],
    metaTitle: 'Free Debt Calculator Ireland — Pay Off Debt Fast | ClearMyDebt',
    metaDesc: 'Calculate your debt free date. Snowball & avalanche. No signup. Instant results.',
  },
  'en-mt': {
    country: 'Malta', currency: 'EUR', symbol: '€', lang: 'en',
    debtTypes: ['Credit Card','Personal Loan','Car Loan','Other'],
    metaTitle: 'Free Debt Calculator Malta — Pay Off Debt Fast | ClearMyDebt',
    metaDesc: 'Calculate your debt free date. Snowball & avalanche. No signup. Instant results.',
  },
  'en-cy': {
    country: 'Cyprus', currency: 'EUR', symbol: '€', lang: 'en',
    debtTypes: ['Credit Card','Personal Loan','Car Loan','Other'],
    metaTitle: 'Free Debt Calculator Cyprus — Pay Off Debt Fast | ClearMyDebt',
    metaDesc: 'Calculate your debt free date. Snowball & avalanche. No signup. Instant results.',
  },
  'en-gi': {
    country: 'Gibraltar', currency: 'GIP', symbol: '£', lang: 'en',
    debtTypes: ['Credit Card','Personal Loan','Other'],
    metaTitle: 'Free Debt Calculator Gibraltar — Pay Off Debt Fast | ClearMyDebt',
    metaDesc: 'Calculate your debt free date. Snowball & avalanche. No signup. Instant results.',
  },

  // ── Europe (local languages) ──
  'de-de': {
    country: 'Germany', currency: 'EUR', symbol: '€', lang: 'de',
    debtTypes: ['Kreditkarte','Ratenkredit','Autokredit','Studentenkredit','Dispositionskredit','Hypothek','Buy Now Pay Later','Familie / Freunde','Sonstiges'],
    metaTitle: 'Schuldenrechner Kostenlos — Schuldenfrei Werden | ClearMyDebt',
    metaDesc: 'Berechne wann du schuldenfrei bist. Ohne Anmeldung. Sofortige Ergebnisse.',
  },
  'fr-fr': {
    country: 'France', currency: 'EUR', symbol: '€', lang: 'fr',
    debtTypes: ['Carte de Crédit','Prêt Personnel','Crédit Auto','Prêt Étudiant','Découvert Bancaire','Crédit Immobilier','Buy Now Pay Later','Famille / Ami','Autre'],
    metaTitle: 'Calculateur de Dettes Gratuit — Rembourser ses Dettes | ClearMyDebt',
    metaDesc: 'Calculez quand vous serez libéré de vos dettes. Sans inscription. Résultats instantanés.',
  },
  'es-es': {
    country: 'Spain', currency: 'EUR', symbol: '€', lang: 'es',
    debtTypes: ['Tarjeta de Crédito','Préstamo Personal','Préstamo de Auto','Préstamo Estudiantil','Descubierto','Hipoteca','Buy Now Pay Later','Familiar / Amigo','Otro'],
    metaTitle: 'Calculadora de Deudas Gratis — Salir de Deudas | ClearMyDebt',
    metaDesc: 'Calcula cuándo estarás libre de deudas. Sin registro. Resultados instantáneos.',
  },
  'it-it': {
    country: 'Italy', currency: 'EUR', symbol: '€', lang: 'it',
    debtTypes: ['Carta di Credito','Prestito Personale','Prestito Auto','Prestito Studentesco','Scoperto Bancario','Mutuo','Buy Now Pay Later','Famiglia / Amici','Altro'],
    metaTitle: 'Calcolatore Gratuito per il Rimborso dei Debiti — ClearMyDebt',
    metaDesc: 'Calcola esattamente quando sarai libero dai debiti. Piano di rimborso personalizzato in pochi secondi.',
  },
  'nl-nl': {
    country: 'Netherlands', currency: 'EUR', symbol: '€', lang: 'nl',
    debtTypes: ['Creditcard','Persoonlijke Lening','Autolening','Studieschuld','Roodstand','Hypotheek','Buy Now Pay Later','Familie / Vriend','Overig'],
    metaTitle: 'Schulden Aflossen Calculator — Schuldenvrij Worden | ClearMyDebt',
    metaDesc: 'Bereken wanneer je schuldenvrij bent. Zonder registratie. Direct resultaat.',
  },
  'pt-pt': {
    country: 'Portugal', currency: 'EUR', symbol: '€', lang: 'pt',
    debtTypes: ['Cartão de Crédito','Empréstimo Pessoal','Crédito Automóvel','Empréstimo Estudantil','Descoberto','Outro'],
    metaTitle: 'Calculadora de Dívidas Grátis — Pagar Dívidas | ClearMyDebt',
    metaDesc: 'Calcule quando ficará livre de dívidas. Sem cadastro. Resultados instantâneos.',
  },
  'pl-pl': {
    country: 'Poland', currency: 'PLN', symbol: 'zł', lang: 'pl',
    debtTypes: ['Karta Kredytowa','Pożyczka Osobista','Kredyt Samochodowy','Kredyt Studencki','Debet','Inne'],
    metaTitle: 'Darmowy Kalkulator Spłaty Długów — ClearMyDebt',
    metaDesc: 'Oblicz dokładnie kiedy będziesz wolny od długów.',
  },
  'sv-se': {
    country: 'Sweden', currency: 'SEK', symbol: 'kr', lang: 'sv',
    debtTypes: ['Kreditkort','Privatlån','Billån','Studielån','Övertrasseringskredit','Annat'],
    metaTitle: 'Gratis Skuldamorteringskalkylator — ClearMyDebt',
    metaDesc: 'Beräkna exakt när du är skuldfri.',
  },
  'nb-no': {
    country: 'Norway', currency: 'NOK', symbol: 'kr', lang: 'nb',
    debtTypes: ['Kredittkort','Personlig Lån','Billån','Studielån','Kassakreditt','Annet'],
    metaTitle: 'Gratis Gjeldskalkulator — ClearMyDebt',
    metaDesc: 'Beregn nøyaktig når du er gjeldfri.',
  },
  'da-dk': {
    country: 'Denmark', currency: 'DKK', symbol: 'kr', lang: 'da',
    debtTypes: ['Kreditkort','Personligt Lån','Billån','Studielån','Kassekredit','Andet'],
    metaTitle: 'Gratis Gældsafviklingskalkulator — ClearMyDebt',
    metaDesc: 'Beregn præcis hvornår du er gældfri.',
  },
  'fi-fi': {
    country: 'Finland', currency: 'EUR', symbol: '€', lang: 'fi',
    debtTypes: ['Luottokortti','Henkilökohtainen Laina','Autolaina','Opintolaina','Luotollinen Tili','Muu'],
    metaTitle: 'Ilmainen Velanmaksukalenteri — ClearMyDebt',
    metaDesc: 'Laske tarkalleen milloin olet velaton.',
  },
  'de-at': {
    country: 'Austria', currency: 'EUR', symbol: '€', lang: 'de',
    debtTypes: ['Kreditkarte','Ratenkredit','Autokredit','Studentenkredit','Dispositionskredit','Sonstiges'],
    metaTitle: 'Schuldenrechner Kostenlos — Schuldenfrei Werden | ClearMyDebt',
    metaDesc: 'Berechne wann du schuldenfrei bist. Ohne Anmeldung. Sofortige Ergebnisse.',
  },
  'fr-be': {
    country: 'Belgium', currency: 'EUR', symbol: '€', lang: 'fr',
    debtTypes: ['Carte de Crédit','Prêt Personnel','Crédit Auto','Prêt Étudiant','Découvert','Autre'],
    metaTitle: 'Calculateur de Dettes Gratuit — Rembourser ses Dettes | ClearMyDebt',
    metaDesc: 'Calculez quand vous serez libéré de vos dettes. Sans inscription. Résultats instantanés.',
  },
  'de-ch': {
    country: 'Switzerland', currency: 'CHF', symbol: 'CHF', lang: 'de',
    debtTypes: ['Kreditkarte','Ratenkredit','Autokredit','Studentenkredit','Sonstiges'],
    metaTitle: 'Schuldenrechner Kostenlos — Schuldenfrei Werden | ClearMyDebt',
    metaDesc: 'Berechne wann du schuldenfrei bist. Ohne Anmeldung. Sofortige Ergebnisse.',
  },
  'de-li': {
    country: 'Liechtenstein', currency: 'CHF', symbol: 'CHF', lang: 'de',
    debtTypes: ['Kreditkarte','Ratenkredit','Sonstiges'],
    metaTitle: 'Schuldenrechner Kostenlos — Schuldenfrei Werden | ClearMyDebt',
    metaDesc: 'Berechne wann du schuldenfrei bist. Ohne Anmeldung. Sofortige Ergebnisse.',
  },
  'et-ee': {
    country: 'Estonia', currency: 'EUR', symbol: '€', lang: 'et',
    debtTypes: ['Krediitkaart','Isiklik Laen','Autolaen','Õppelaen','Arvelduskrediit','Muu'],
    metaTitle: 'Tasuta Võlakalkulaator — ClearMyDebt',
    metaDesc: 'Arvuta täpselt millal oled võlgadest vaba.',
  },
  'lv-lv': {
    country: 'Latvia', currency: 'EUR', symbol: '€', lang: 'lv',
    debtTypes: ['Kredītkarte','Personīgais Aizdevums','Auto Aizdevums','Studiju Aizdevums','Overdrafts','Cits'],
    metaTitle: 'Bezmaksas Parādu Kalkulators — ClearMyDebt',
    metaDesc: 'Aprēķiniet precīzi kad būsit brīvs no parādiem.',
  },
  'lt-lt': {
    country: 'Lithuania', currency: 'EUR', symbol: '€', lang: 'lt',
    debtTypes: ['Kredito Kortelė','Asmeninė Paskola','Auto Paskola','Studijų Paskola','Sąskaitos Overdraftas','Kita'],
    metaTitle: 'Nemokamas Skolų Skaičiuoklė — ClearMyDebt',
    metaDesc: 'Apskaičiuokite tiksliai kada būsite be skolų.',
  },
  'sk-sk': {
    country: 'Slovakia', currency: 'EUR', symbol: '€', lang: 'sk',
    debtTypes: ['Kreditná Karta','Osobná Pôžička','Auto Úver','Študentský Úver','Kontokorent','Iné'],
    metaTitle: 'Bezplatná Kalkulačka Splácania Dlhov — ClearMyDebt',
    metaDesc: 'Vypočítajte presne kedy budete bez dlhov.',
  },
  'sl-si': {
    country: 'Slovenia', currency: 'EUR', symbol: '€', lang: 'sl',
    debtTypes: ['Kreditna Kartica','Osebno Posojilo','Avtomobilsko Posojilo','Študentsko Posojilo','Prekoračitev','Drugo'],
    metaTitle: 'Brezplačni Kalkulator Odplačevanja Dolgov — ClearMyDebt',
    metaDesc: 'Izračunajte natančno kdaj boste brez dolgov.',
  },
  'bg-bg': {
    country: 'Bulgaria', currency: 'BGN', symbol: 'лв', lang: 'bg',
    debtTypes: ['Кредитна Карта','Личен Заем','Автокредит','Студентски Заем','Овердрафт','Друго'],
    metaTitle: 'Безплатен Калкулатор за Изплащане на Дългове — ClearMyDebt',
    metaDesc: 'Изчислете точно кога ще бъдете без дългове.',
  },
  'ro-ro': {
    country: 'Romania', currency: 'RON', symbol: 'lei', lang: 'ro',
    debtTypes: ['Card de Credit','Împrumut Personal','Credit Auto','Credit Studențesc','Descoperit de Cont','Altele'],
    metaTitle: 'Calculator Gratuit de Rambursare a Datoriilor — ClearMyDebt',
    metaDesc: 'Calculați exact când veți fi fără datorii.',
  },
  'hu-hu': {
    country: 'Hungary', currency: 'HUF', symbol: 'Ft', lang: 'hu',
    debtTypes: ['Hitelkártya','Személyi Kölcsön','Autóhitel','Diákhitel','Folyószámlahitel','Egyéb'],
    metaTitle: 'Ingyenes Adósságtörlesztési Kalkulátor — ClearMyDebt',
    metaDesc: 'Számítsa ki pontosan mikor lesz adósságmentes.',
  },
  'cs-cz': {
    country: 'Czech Republic', currency: 'CZK', symbol: 'Kč', lang: 'cs',
    debtTypes: ['Kreditní Karta','Osobní Půjčka','Autoúvěr','Studentská Půjčka','Kontokorent','Jiné'],
    metaTitle: 'Bezplatná Kalkulačka Splácení Dluhů — ClearMyDebt',
    metaDesc: 'Vypočítejte přesně kdy budete bez dluhů.',
  },
  'fr-lu': {
    country: 'Luxembourg', currency: 'EUR', symbol: '€', lang: 'fr',
    debtTypes: ['Carte de Crédit','Prêt Personnel','Crédit Auto','Découvert','Autre'],
    metaTitle: 'Calculateur de Dettes Gratuit Luxembourg — ClearMyDebt',
    metaDesc: 'Calculez quand vous serez libre de dettes.',
  },

  // ── South Asia ──
  'en-in': {
    country: 'India', currency: 'INR', symbol: '₹', lang: 'en',
    debtTypes: ['Credit Card','Personal Loan','Home Loan','Car Loan','Education Loan','EMI / Buy Now Pay Later','Gold Loan','Medical Loan','Business Loan','Other'],
    metaTitle: 'Free Debt Calculator India — Pay Off Debt Fast | ClearMyDebt',
    metaDesc: "Calculate when you'll be debt free in India. Snowball and avalanche method. No signup. Instant results.",
  },

  // ── Asia-Pacific ──
  'en-au': {
    country: 'Australia', currency: 'AUD', symbol: 'A$', lang: 'en',
    debtTypes: ['Credit Card','Personal Loan','Car Loan','HECS-HELP (Student Debt)','Home Loan','Buy Now Pay Later','Overdraft','Family / Friend Loan','Other'],
    metaTitle: 'Free Loan Repayment Calculator — Pay Off Debt Faster | ClearMyDebt',
    metaDesc: 'Calculate your loan repayment plan. Snowball & avalanche. No signup. Instant results.',
  },
  'en-nz': {
    country: 'New Zealand', currency: 'NZD', symbol: 'NZ$', lang: 'en',
    debtTypes: ['Credit Card','Personal Loan','Car Loan','Student Loan','Overdraft','Buy Now Pay Later','Family / Friend Loan','Other'],
    metaTitle: 'Free Debt Calculator New Zealand — Pay Off Debt Fast | ClearMyDebt',
    metaDesc: 'Calculate your debt free date. Snowball & avalanche. No signup. Instant results.',
  },
  'en-sg': {
    country: 'Singapore', currency: 'SGD', symbol: 'S$', lang: 'en',
    debtTypes: ['Credit Card','Personal Loan','Car Loan','Study Loan','Renovation Loan','Buy Now Pay Later','Family / Friend Loan','Other'],
    metaTitle: 'Free Debt Calculator Singapore — Pay Off Debt Fast | ClearMyDebt',
    metaDesc: 'Calculate your debt free date. Snowball & avalanche. No signup. Instant results.',
  },
  'en-hk': {
    country: 'Hong Kong', currency: 'HKD', symbol: 'HK$', lang: 'en',
    debtTypes: ['Credit Card','Personal Loan','Car Loan','Tax Loan','Buy Now Pay Later','Family / Friend Loan','Other'],
    metaTitle: 'Free Debt Calculator Hong Kong — Pay Off Debt Fast | ClearMyDebt',
    metaDesc: 'Calculate your debt free date. Snowball & avalanche. No signup. Instant results.',
  },
  'en-my': {
    country: 'Malaysia', currency: 'MYR', symbol: 'RM', lang: 'en',
    debtTypes: ['Credit Card','Personal Loan','Car Loan','Study Loan','Buy Now Pay Later','Family / Friend Loan','Other'],
    metaTitle: 'Free Debt Calculator Malaysia — Pay Off Debt Fast | ClearMyDebt',
    metaDesc: 'Calculate your debt free date. Snowball & avalanche. No signup. Instant results.',
  },
  'ja-jp': {
    country: 'Japan', currency: 'JPY', symbol: '¥', lang: 'ja',
    debtTypes: ['クレジットカード','カードローン','自動車ローン','教育ローン','住宅ローン','キャッシング','その他'],
    metaTitle: '借金返済計算機 無料 — 負債整理 | ClearMyDebt',
    metaDesc: '借金がいつ完済できるか計算。登録不要。即座に結果。',
  },
  'th-th': {
    country: 'Thailand', currency: 'THB', symbol: '฿', lang: 'th',
    debtTypes: ['บัตรเครดิต','สินเชื่อส่วนบุคคล','สินเชื่อรถยนต์','กู้ยืมเพื่อการศึกษา','บัตรกดเงินสด','อื่นๆ'],
    metaTitle: 'เครื่องคำนวณการชำระหนี้ฟรี — ClearMyDebt',
    metaDesc: 'คำนวณว่าเมื่อไหรคุณจะหมดหนี้ แผนการชำระหนี้ส่วนตัวใน ไม่กี่วินาที',
  },

  // ── Africa ──
  'en-gh': {
    country: 'Ghana', currency: 'GHS', symbol: 'GH₵', lang: 'en',
    debtTypes: ['Credit Card','Personal Loan','Car Loan','Mobile Money Loan','Other'],
    metaTitle: 'Free Debt Calculator Ghana — Pay Off Debt Fast | ClearMyDebt',
    metaDesc: 'Calculate your debt free date. Snowball & avalanche. No signup. Instant results.',
  },
  'en-ke': {
    country: 'Kenya', currency: 'KES', symbol: 'KES', lang: 'en',
    debtTypes: ['Credit Card','Personal Loan','Car Loan','Mobile Loan (M-Shwari)','SACCO Loan','Other'],
    metaTitle: 'Free Debt Calculator Kenya — Pay Off Debt Fast | ClearMyDebt',
    metaDesc: 'Calculate your debt free date. Snowball & avalanche. No signup. Instant results.',
  },
  'en-ng': {
    country: 'Nigeria', currency: 'NGN', symbol: '₦', lang: 'en',
    debtTypes: ['Credit Card','Personal Loan','Car Loan','Business Loan','Buy Now Pay Later','Other'],
    metaTitle: 'Free Debt Calculator Nigeria — Pay Off Debt Fast | ClearMyDebt',
    metaDesc: 'Calculate your debt free date. Snowball & avalanche. No signup. Instant results.',
  },
  'en-za': {
    country: 'South Africa', currency: 'ZAR', symbol: 'R', lang: 'en',
    debtTypes: ['Credit Card','Personal Loan','Car Loan','Home Loan','Store Account','Buy Now Pay Later','Other'],
    metaTitle: 'Free Debt Calculator South Africa — Pay Off Debt Fast | ClearMyDebt',
    metaDesc: 'Calculate your debt free date. Snowball & avalanche. No signup. Instant results.',
  },

  // ── Middle East ──
  'en-ae': {
    country: 'United Arab Emirates', currency: 'AED', symbol: 'AED', lang: 'en',
    debtTypes: ['Credit Card','Personal Loan','Car Loan','Buy Now Pay Later','Family / Friend Loan','Other'],
    metaTitle: 'Free Debt Calculator UAE — Pay Off Debt Fast | ClearMyDebt',
    metaDesc: 'Calculate your debt free date. Snowball & avalanche. No signup. Instant results.',
  },
};

export const DEFAULT_LOCALE = 'en-us';

// ISO 3166-1 alpha-2 → locale key
export const COUNTRY_TO_LOCALE = {
  // North America
  'US': 'en-us', 'CA': 'en-ca', 'MX': 'es-mx', 'BR': 'pt-br',
  'AR': 'es-ar', 'CO': 'es-co', 'CL': 'es-cl', 'IN': 'en-in',
  // UK & Gibraltar
  'GB': 'en-gb', 'GI': 'en-gi',
  // Eurozone (западная)
  'IE': 'en-ie', 'DE': 'de-de', 'FR': 'fr-fr', 'NL': 'nl-nl',
  'AT': 'de-at', 'BE': 'fr-be', 'FI': 'fi-fi', 'LU': 'fr-lu',
  'CH': 'de-ch', 'LI': 'de-li',
  // Скандинавия
  'SE': 'sv-se', 'NO': 'nb-no', 'DK': 'da-dk',
  // Южная Европа
  'ES': 'es-es', 'IT': 'it-it', 'PT': 'pt-pt', 'MT': 'en-mt', 'CY': 'en-cy',
  // Восточная Европа
  'PL': 'pl-pl', 'CZ': 'cs-cz', 'HU': 'hu-hu', 'RO': 'ro-ro', 'BG': 'bg-bg',
  'SK': 'sk-sk', 'SI': 'sl-si', 'EE': 'et-ee', 'LV': 'lv-lv', 'LT': 'lt-lt',
  // Asia-Pacific
  'AU': 'en-au', 'NZ': 'en-nz', 'SG': 'en-sg', 'HK': 'en-hk',
  'MY': 'en-my', 'JP': 'ja-jp', 'TH': 'th-th',
  // Middle East
  'AE': 'en-ae',
  // Africa
  'GH': 'en-gh', 'KE': 'en-ke', 'NG': 'en-ng', 'ZA': 'en-za',
};

// Browser language tag → locale key (фоллбек)
export const BROWSER_LANG_TO_LOCALE = {
  'en-gb': 'en-gb', 'en-au': 'en-au', 'en-ca': 'en-ca',
  'en-nz': 'en-nz', 'en-ie': 'en-ie', 'en-sg': 'en-sg',
  'en-hk': 'en-hk', 'en-my': 'en-my', 'en-za': 'en-za',
  'de-de': 'de-de', 'de-at': 'de-at', 'de-ch': 'de-ch',
  'fr-fr': 'fr-fr', 'fr-be': 'fr-be', 'fr-lu': 'fr-lu', 'fr-ch': 'de-ch',
  'es-us': 'es-us', 'es-es': 'es-es', 'es-ar': 'es-ar', 'es-co': 'es-co', 'es-cl': 'es-cl',
  'it-it': 'it-it', 'pt-pt': 'pt-pt',
  'nl-nl': 'nl-nl', 'nl-be': 'fr-be',
  'pl-pl': 'pl-pl', 'cs-cz': 'cs-cz', 'hu-hu': 'hu-hu',
  'ro-ro': 'ro-ro', 'bg-bg': 'bg-bg', 'sk-sk': 'sk-sk',
  'sl-si': 'sl-si', 'et-ee': 'et-ee', 'lv-lv': 'lv-lv',
  'lt-lt': 'lt-lt', 'sv-se': 'sv-se', 'nb-no': 'nb-no',
  'da-dk': 'da-dk', 'fi-fi': 'fi-fi',
  'ja-jp': 'ja-jp', 'th-th': 'th-th',
};

// Кеш чтобы не делать повторные fetch
let _cachedLocale = null;

// Sync version — reads from URL path and browser language only (no async fetch).
// Use this in components that need locale at render time.
export function detectLocaleSync() {
  if (typeof window === 'undefined') return DEFAULT_LOCALE;
  if (_cachedLocale) return _cachedLocale;

  const pathMatch = window.location.pathname.match(/^\/([a-z]{2}-[a-z]{2})\//i);
  if (pathMatch && LOCALE_CONFIG[pathMatch[1].toLowerCase()]) {
    return pathMatch[1].toLowerCase();
  }

  const browserLang = navigator?.language?.toLowerCase();
  if (browserLang) {
    if (BROWSER_LANG_TO_LOCALE[browserLang]) return BROWSER_LANG_TO_LOCALE[browserLang];
    const langOnly = browserLang.split('-')[0];
    const match = Object.keys(LOCALE_CONFIG).find(k => k.startsWith(langOnly + '-'));
    if (match) return match;
  }

  return DEFAULT_LOCALE;
}

export async function detectLocale() {
  if (typeof window === 'undefined') return DEFAULT_LOCALE;
  if (_cachedLocale) return _cachedLocale;

  // 1. URL-путь — самый надёжный сигнал
  const pathMatch = window.location.pathname.match(/^\/([a-z]{2}-[a-z]{2})\//i);
  if (pathMatch && LOCALE_CONFIG[pathMatch[1].toLowerCase()]) {
    _cachedLocale = pathMatch[1].toLowerCase();
    return _cachedLocale;
  }

  // 2. Dev override через env
  if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_DEFAULT_LOCALE) {
    _cachedLocale = process.env.REACT_APP_DEFAULT_LOCALE;
    return _cachedLocale;
  }

  // 3. Netlify Edge — определение по IP
  try {
    const res = await fetch('/.netlify/functions/get-locale');
    if (res.ok) {
      const { country } = await res.json();
      const locale = COUNTRY_TO_LOCALE[country];
      if (locale) {
        _cachedLocale = locale;
        return _cachedLocale;
      }
    }
  } catch {
    // Netlify недоступен (локальная разработка) — идём дальше
  }

  // 4. Язык браузера — фоллбек
  const browserLang = navigator.language?.toLowerCase();
  if (browserLang) {
    if (BROWSER_LANG_TO_LOCALE[browserLang]) {
      _cachedLocale = BROWSER_LANG_TO_LOCALE[browserLang];
      return _cachedLocale;
    }
    const langOnly = browserLang.split('-')[0];
    const match = Object.keys(LOCALE_CONFIG).find(k => k.startsWith(langOnly + '-'));
    if (match) {
      _cachedLocale = match;
      return _cachedLocale;
    }
  }

  // 5. Дефолт — США
  _cachedLocale = DEFAULT_LOCALE;
  return _cachedLocale;
}

export function formatCurrency(amount, localeKey) {
  const cfg = LOCALE_CONFIG[localeKey] || LOCALE_CONFIG[DEFAULT_LOCALE];
  return new Intl.NumberFormat(localeKey, {
    style: 'currency',
    currency: cfg.currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}
